export const EVENT_LINK_EXPIRED = {
  title: 'Your link has expired',
  content:
    'To protect your medical information, this link was only available to use for 72 hours. For long term access to your medical records, try out My Health+',
  buttonText: 'Continue to'
};

export const EVENT_LINK_LOGIN = {
  subTitle: 'Your health matters to us',
  content: ' To access test results please enter the information below.'
};

export const MY_HEALTH_PLUS_DOWNLOAD_SPLASH =
  'https://intermountainhealthcare.org/patient-tools/my-health-plus/';
